import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-8 md:pt-20 pb-10 px-4 text-center" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <div className="mb-3 md:mb-6" data-id="element-152">
          <span className="text-brand-secondary font-black tracking-[0.2em] text-xs sm:text-sm uppercase bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-153">
            GUIADIGITAL360™
          </span>
        </div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mt-2 mb-2 md:mt-4 md:mb-4 leading-tight tracking-tight" data-id="element-154">
          Aprendé el Oficio que <br data-id="element-155" />
          <span className="text-brand-primary underline decoration-brand-secondary decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-156">
            Más Paga en Argentina
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-blue-50 max-w-3xl mx-auto mb-3 md:mb-4 leading-relaxed font-medium" data-id="element-157">
          El sistema completo para instalar, reparar y diagnosticar aires y
          heladeras — y empezar a generar ingresos reales esta semana.
        </p>

        <div className="mb-3 max-w-md mx-auto aspect-[16/9] overflow-hidden rounded-xl bg-white/5" data-id="element-158">
          <picture data-id="element-159">
            <source srcSet="https://cdn.magicpatterns.com/uploads/jepLYJv1a4XGZs99UfsQ4i/refrigeracion_hero_mobile_768.webp" media="(max-width: 768px)" data-id="element-160" />
            <img src="https://cdn.magicpatterns.com/uploads/jepLYJv1a4XGZs99UfsQ4i/refrigeracion_hero_mobile_768.webp" alt="Maestro de Refrigeración - Pack Completo" className="w-full h-full object-cover" width="768" height="432" fetchPriority="high" loading="eager" decoding="async" data-id="element-161" />
          </picture>
        </div>

        <div className="flex flex-col items-center gap-2 mb-4 md:mb-6" data-id="element-162">
          <div className="flex gap-3" data-id="element-163">
            <span className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-white border border-white/20" data-id="element-164">
              📄 100% Digital
            </span>
            <span className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-white border border-white/20" data-id="element-165">
              ⚡ Acceso Inmediato
            </span>
          </div>
          <span className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-white border border-white/20" data-id="element-166">
            🇦🇷 Hecho en Argentina
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-3 md:mb-4" data-id="element-167">
          <CTAButton text="🔥 → QUIERO EMPEZAR HOY" href="#empezar" isLink={true} data-id="element-168" />
        </div>

        <div className="max-w-xl mx-auto mb-4 md:mb-5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4" data-id="element-169">
          <p className="text-sm font-bold text-white mb-2" data-id="element-170">
            🔒 Tu pago es 100% seguro
          </p>
          <div className="text-xs text-blue-100 space-y-1 text-left" data-id="element-171">
            <p data-id="element-172">✅ No necesitás tener cuenta en Mercado Pago</p>
            <p data-id="element-173">✅ Podés pagar con tarjeta de débito o crédito</p>
            <p data-id="element-174">✅ También aceptamos transferencia bancaria o CVU</p>
            <p data-id="element-175">✅ Tus datos están protegidos en todo momento</p>
            <p className="pt-2" data-id="element-176">
              📩 En menos de 5 minutos recibís todo en tu email
            </p>
            <p data-id="element-177">⚠️ Si no lo ves, revisá Spam o Promociones</p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 text-sm md:text-base text-blue-50 font-medium mb-3 md:mb-4" data-id="element-178">
          <span className="flex items-center gap-1" data-id="element-179">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-180" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-181">
            <LockIcon className="w-5 h-5 text-blue-300" data-id="element-182" /> Pago 100% seguro vía
            Mercado Pago
          </span>
        </div>

        <div className="max-w-lg mx-auto bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-3" data-id="element-183">
          <div className="text-xs text-blue-50 space-y-1 text-center" data-id="element-184">
            <p data-id="element-185">🔒 Pago seguro · No necesitás cuenta en MP</p>
            <p data-id="element-186">💳 Débito · Crédito · Transferencia · CVU</p>
            <p data-id="element-187">📩 Acceso inmediato por email</p>
          </div>
        </div>
      </div>
    </section>;
}